import format from '_shared_/plugins/format';
const mutations = {
  SET_MSTAR_RATINGS(state, payload) {
    const mstarRatingsArray = [];
    mstarRatingsArray.push({
      title: 'Overall Morningstar Rating',
      count: payload.mstarRatings.MStarCategoryCount3Yr, //Per requirements the overall will be the same as 3 years.
      rating: payload.mstarRatings.MStarRatingOverall
    });
    mstarRatingsArray.push({
      title: '3-yr. Morningstar Rating',
      count: payload.mstarRatings.MStarCategoryCount3Yr,
      rating: payload.mstarRatings.MStarRating3Yr
    });
    mstarRatingsArray.push({
      title: '5-yr. Morningstar Rating',
      count: payload.mstarRatings.MStarCategoryCount5Yr,
      rating: payload.mstarRatings.MStarRating5Yr
    });
    mstarRatingsArray.push({
      title: '10-yr. Morningstar Rating',
      count: payload.mstarRatings.MStarCategoryCount10Yr,
      rating: payload.mstarRatings.MStarRating10Yr
    });
    state.mstar = {
      mStarCategory: payload.mstarRatings.MStarCategory,
      mStarRiskRatingOverall: payload.mstarRatings.MStarRiskRatingOverall,
      mStarRiskRatingOverallTxt: payload.mstarRatings.MStarRiskRatingOverallTxt,
      mstarAsOfDate: format.formatHelpers.shortDate(payload.mstarRatings.MStarFundAsOfDate),
      mstarRatingsArray,
      blueStarImg: require('_assets_/img/blue_star_icon.png'),
      greyStarImg: require('_assets_/img/gray_star_icon.png')
    };
  }
};
const getters = {
  getMstarRating: state => state.mstar || {}
};

const state = {
  mstar: null
};

export default {
  state,
  getters,
  mutations
};
